import React from 'react'

import { ReactComponent as FrameIcon } from '@sketch/icons/frame-17'
import { ReactComponent as TextIcon } from '@sketch/icons/textformat-17'
import { ReactComponent as ShapeIcon } from '@sketch/icons/squares-2-17'
import { ReactComponent as GroupIcon } from '@sketch/icons/folder-open-17'
import { ReactComponent as BitmapIcon } from '@sketch/icons/image-17'
import { ReactComponent as SliceIcon } from '@sketch/icons/square-knife-16'
import { ReactComponent as SymbolIcon } from '@sketch/icons/symbol-17'
import { ReactComponent as GraphicIcon } from '@sketch/icons/img-frame-graphic-17'

import { ExportableIcon } from '../../ExportableIcon'
import { ElementType } from '../../../../../inspector'

import * as S from './ElementIcon.styles'

export interface ElementIconProps {
  maskColor?: string
  elementType: ElementType
  isLayerMasked: boolean
  isLayerExportable: boolean
}
export function ElementIcon({
  elementType,
  maskColor,
  isLayerMasked,
  isLayerExportable,
}: ElementIconProps) {
  return (
    <S.ElementIconContainer>
      {isLayerMasked && <S.StyledMaskedIcon />}
      <ContextMenuLayerIcon elementType={elementType} />
      {/* Slice already has an exportable icon present on the icon */}
      {isLayerExportable && elementType !== 'slice' && (
        <ExportableIcon maskColor={maskColor} />
      )}
    </S.ElementIconContainer>
  )
}

interface ContextMenuLayerIconProps {
  elementType: ElementType
}

// Gets the element icon url based on the element type.
const ContextMenuLayerIcon = ({ elementType }: ContextMenuLayerIconProps) => {
  switch (elementType) {
    case 'artboard':
      return <FrameIcon width={17} height={17} />
    case 'graphic':
      return <GraphicIcon width={17} height={17} />
    case 'bitmap':
      return <BitmapIcon width={17} height={17} />
    case 'text':
      return <TextIcon width={17} height={17} />
    case 'group':
      return <GroupIcon width={17} height={17} />
    case 'slice':
      return <SliceIcon width={17} height={17} />
    case 'symbolMaster':
    case 'symbolInstance':
      return <SymbolIcon width={17} height={17} />
    default:
      return <ShapeIcon width={17} height={17} />
  }
}
